import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const StatusActive = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none"><circle cx="11.5" cy="11.5" r="11.5" fill="#343D2F" /><circle cx="11.5003" cy="11.5004" r="6.08824" fill="#6DD33D" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default StatusActive;